import { useTanstack } from "../../hooks/useTanstack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getNestedPages } from "../../utils/formatters";
import styles from "./ui.module.scss";

export const NestedPages = () => {
  const navigate = useNavigate();

  const { language } = useParams();
  const { pathname } = useLocation();
  const { data } = useTanstack("getWebItems");

  const nestedPages = getNestedPages(data, pathname);

  if (nestedPages?.length == 1) {
    return;
  }

  return (
    nestedPages && (
      <ul className={styles.nestedPages}>
        {nestedPages?.map(({ id, name, path }) => {
          const isActive = pathname === `/${language}/${path}`;

          return (
            <li
              key={id}
              className={
                isActive
                  ? styles.nestedPages_linkActive
                  : styles.nestedPages_link
              }
              onClick={() => !isActive && navigate(`/${language}/${path}`)}
            >
              {name}
            </li>
          );
        })}
      </ul>
    )
  );
};
